import React from 'react';
import { MenuLink } from '@src/modules/Layout/shared/MenuLink';
import { LOCATIONS_ROUTES } from '../../constants';
import { Icon } from '@therms/atalaya';
import { MdBusiness } from 'react-icons/md';

function LocationsMenuLink() {
  return (
    <MenuLink to={LOCATIONS_ROUTES.__ROOT__}>
      <div className="inline-flex items-center gap-x-sm">
        <Icon Icon={MdBusiness} />
        <span>Locations</span>
      </div>
    </MenuLink>);

}

export { LocationsMenuLink };